import React from 'react';
import { useResponsiveStyles } from '../../useResponsiveStyles';


const ModernHeaderFooterCard = ({ header, footer, title, bodyText, styles = {} }) => {

    const appliedStyles = useResponsiveStyles(styles);

    return (
        <div className="card modern-hf-card">
            <div className="card-header modern-header" style={appliedStyles.header || {}}>
                {header}
            </div>
            <div className="card-body">
                <h5 className="card-title" style={appliedStyles.title || {}}>
                    {title}
                </h5>
                <p className="card-text" style={appliedStyles.bodyText || {}}>
                    {bodyText}
                </p>
                <a href={appliedStyles.button?.link || "#"} className="btn modern-btn" style={appliedStyles.button || {}}>
                    {appliedStyles.button?.text || "Learn More"}
                </a>
            </div>
            <div className="card-footer modern-footer" style={appliedStyles.footer || {}}>
                {footer}
            </div>
        </div>
    );
};

export default ModernHeaderFooterCard;
